// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"e938cd7a","975":"0ec6c58f"}[chunkId] + ".chunk.js";
};